import { render } from "./Transfers.vue?vue&type=template&id=c8e9e808&ts=true"
import script from "./Transfers.vue?vue&type=script&lang=ts"
export * from "./Transfers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__